module.exports = __webpack_public_path__ + "static/media/bagy11.e449e4a3.png";